/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-undef */
import { configureStore } from '@reduxjs/toolkit'
import { Reducer } from 'redux'
import { Persistor, persistStore } from 'redux-persist'

import { asyncReducerHydrated } from 'actions/ui/app'
import { resetPaginationMiddleware } from 'features/App/pagination/resetPaginationMiddleware'
import { sentryReduxMiddleware } from 'features/Monitoring/Sentry'
import { DynamicReducerKey, DynamicReducerOptions } from 'reducers/ui/ui'

import { buildRootReducer, injectReducer as injectUiReducer } from './reducers'
import storeRegistry from './utilities/storeRegistry'

// create redux store with redux tools in development and beta stages
const store = configureStore({
    reducer: buildRootReducer(),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false, // We are currently adding some non-serializable items to the store like Dayjs objects
        }).concat(resetPaginationMiddleware, sentryReduxMiddleware),
    devTools: {
        trace: true,
    },
})

// redux persist
let persistor = persistStore(store)

const injectReducerToStore = (
    key: DynamicReducerKey,
    reducer: Reducer<any, any>,
    options: DynamicReducerOptions = {}
): void => {
    injectUiReducer(key, reducer, options)
    store.replaceReducer(buildRootReducer())
    persistor.persist()
    store.dispatch(
        asyncReducerHydrated({
            key,
            initialState: reducer(undefined, { type: '@@INIT' }),
        })
    )
}

// register store for access outside of components while avoid circular references
storeRegistry.registerStore(store)

if (module.hot) {
    module.hot.accept('./reducers', () => {
        const newReducers = require('./reducers')
        store.replaceReducer(newReducers.buildRootReducer())
        persistor.persist()
    })
}

const getPersistor = (): Persistor => persistor

export { store, getPersistor, injectReducerToStore }
